import React from "react";

import { useParams } from "react-router-dom";
import useFetchProductsDetail from "../../lib/hooks/use-fetch-products-detail";
import useFetchCategories from "../../lib/hooks/use-fetch-categories";
import { getCurrentUser } from "../../lib/auth_base/localstorage";
import EditProductForm from "./ui/edit-products-form";



export default  function EditProduct() {
  const par:any = useParams();

  console.log("EditProduct::par: ", par);
  const {products,loading} = useFetchProductsDetail({ slug: par.url }); 

  const {categories} = useFetchCategories(); 
  const user = getCurrentUser();
  return (
    <React.Fragment>
      
     {products ? <EditProductForm
        categories={categories}
        product={products}
      /> : <div>Loading...</div>}
    </React.Fragment>
  );
}
